// Page "Aide & FAQ" — navigation par categorie + recherche (brief dedie,
// 2026-08-15). Progressive enhancement : sections/faq-browser.liquid rend
// TOUTES les categories et TOUTES les questions visibles sans JS (brief
// §8 "fonctionnement degrade") ; ce script bascule vers un mode "1
// categorie a la fois + recherche live" une fois charge.
//
// 2026-09-03 : trackEvent() relaie "category-select"/"question-open" vers
// window.HexagonAnalytics (Shopify.analytics.publish) — "search"/"search-
// noresults" volontairement exclus (voir plus bas), trop bruyants (pas de
// debounce sur l'input de recherche).
//
// Decouple de sections/faq-hero-search.liquid (le champ de recherche peut
// vivre dans une section differente, plus haut dans la page) via un id
// DOM partage (#faq-search-input) plutot qu'un CustomEvent — plus simple,
// une seule page ne peut avoir qu'un seul champ de recherche FAQ actif.
(function () {
  var root = document.querySelector('[data-faq-browser]');
  if (!root) return;

  var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
  var noResults = root.querySelector('[data-faq-noresults]');
  var resultsWrap = root.querySelector('[data-faq-results]');
  var clearBtn = root.querySelector('[data-faq-clear]');
  var searchInput = document.getElementById('faq-search-input');
  var searchForm = document.querySelector('[data-faq-search-form]');

  // 2026-09-03 : "search"/"search-noresults" exclus du pont HexagonAnalytics
  // — declenches a chaque frappe clavier (pas de debounce sur l'input de
  // recherche), donc trop bruyant pour de l'analytics tel quel. Le
  // CustomEvent interne reste emis pour les 2, inchange.
  var ANALYTICS_EXCLUDED = { 'search': true, 'search-noresults': true };
  function trackEvent(name, detail) {
    var fullName = 'hexagon:faq-' + name;
    document.dispatchEvent(new CustomEvent(fullName, { detail: detail || {} }));
    if (window.HexagonAnalytics && !ANALYTICS_EXCLUDED[name]) window.HexagonAnalytics.publish(fullName, detail);
  }

  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function setActiveCategory(slug) {
    categoryButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-faq-category') === slug;
      btn.setAttribute('aria-selected', String(isActive));
    });
    groups.forEach(function (group) {
      group.hidden = group.getAttribute('data-faq-group') !== slug;
    });
  }

  function applySearch(query) {
    var q = normalize(query);
    if (!q) {
      noResults.hidden = true;
      resultsWrap.hidden = false;
      var active = categoryButtons.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0];
      setActiveCategory(active ? active.getAttribute('data-faq-category') : categoryButtons[0].getAttribute('data-faq-category'));
      return;
    }

    var totalMatches = 0;
    categoryButtons.forEach(function (btn) { btn.setAttribute('aria-selected', 'false'); });

    groups.forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-faq-item]'));
      var groupMatches = 0;
      items.forEach(function (item) {
        var text = normalize(item.getAttribute('data-faq-search-text'));
        var isMatch = text.indexOf(q) !== -1;
        item.hidden = !isMatch;
        if (isMatch) groupMatches += 1;
      });
      group.hidden = groupMatches === 0;
      totalMatches += groupMatches;
    });

    resultsWrap.hidden = totalMatches === 0;
    noResults.hidden = totalMatches !== 0;
    trackEvent(totalMatches === 0 ? 'search-noresults' : 'search', { query: query, results: totalMatches });
  }

  categoryButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      setActiveCategory(btn.getAttribute('data-faq-category'));
      trackEvent('category-select', { category: btn.getAttribute('data-faq-category') });
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () { applySearch(searchInput.value); });
  }
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      applySearch(searchInput ? searchInput.value : '');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      applySearch('');
      if (searchInput) searchInput.focus();
    });
  }

  root.querySelectorAll('.faq-item__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      if (item && !item.hidden && item.classList.contains('is-open')) {
        trackEvent('question-open', { question: btn.textContent.trim() });
      }
    });
  });

  // Ancre partageable : #remplacer ouvre la categorie, un id de question
  // (voir handleize sur faq-popular.liquid) ouvre directement la reponse.
  var hash = window.location.hash.replace('#', '');
  var hashCategory = categoryButtons.filter(function (b) { return b.getAttribute('data-faq-category') === hash; })[0];
  if (hashCategory) {
    setActiveCategory(hash);
  } else {
    setActiveCategory(categoryButtons.length ? categoryButtons[0].getAttribute('data-faq-category') : null);
    if (hash) {
      var target = document.getElementById(hash);
      if (target && target.classList.contains('faq-item')) {
        var q = target.querySelector('.faq-item__question');
        if (q) q.click();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
})();
